import WebpackerReact from 'webpacker-react';
import React, { useState, useEffect } from 'react';
import Donutchart from '../GeneralComponents/ApexCharts/donutChart'
import CardData from '../GeneralComponents/bw-ui/CardData';
import CardDataThree from '../GeneralComponents/bw-ui/CardDataThree';
import Columnchart from '../GeneralComponents/ApexCharts/columnChart'
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import Preloader from '../GeneralComponents/LoadingComponen';

const TrafficLights = ({ variant }) => {
    const imgs = variant === 'company' ? {
        red: "https://beewo.s3.amazonaws.com/uploads/survey_answer/answer_file/12602/Imagen_1_Rojo_semaforo_empresa.png",
        orange: "https://beewo.s3.amazonaws.com/uploads/survey_answer/answer_file/12603/Imagen_3_Amarillo_semaforo_empresa.png",
        green: "https://beewo.s3.amazonaws.com/uploads/survey_answer/answer_file/12604/Imagen2_verde_semaforo_de_empresa.png",
    } : {
        red: "https://beewo.s3.amazonaws.com/uploads/survey_answer/answer_file/12605/Imagen_1_Rojo_semaforo_empleado.png",
        orange: "https://beewo.s3.amazonaws.com/uploads/survey_answer/answer_file/12606/Imagen_3_Amarillo_semaforo_empleado.png",
        green: "https://beewo.s3.amazonaws.com/uploads/survey_answer/answer_file/12607/Imagen2_verde_semaforo_de_empleado.png",
    };

    const Item = ({ id, colorClass, img }) => (
        <>
            <button type="button" id={id} className={`md-light md-light--${colorClass}`} aria-label="Ver leyenda">
                <i className="fas fa-info-circle" />
            </button>
            <UncontrolledPopover trigger="legacy" placement="bottom" target={id}>
                <PopoverBody className="p-0">
                    <div className="dashboard-poppover md-popover-img">
                        <img src={img} alt="" />
                    </div>
                </PopoverBody>
            </UncontrolledPopover>
        </>
    );

    return (
        <div className="md-hero-lights">
            <Item id={`md-tl-red-${variant}`} colorClass="red" img={imgs.red} />
            <Item id={`md-tl-orange-${variant}`} colorClass="amber" img={imgs.orange} />
            <Item id={`md-tl-green-${variant}`} colorClass="green" img={imgs.green} />
        </div>
    );
};

const MyDashboard = (props) => {

    const sessionUser = props.current_user || props.currentUser;
    const dashboardUsers = Array.isArray(props.users) ? props.users : [];

    const [isLoaded, setIsLoaded] = useState(true);
    const [filterUserId, setFilterUserId] = useState('');
    const [data, setData] = useState({
        user: {
            name: "",
            position: "",
            avatar: "",
        },

        tasks: {
            count: 0,
            expired: 0,
            performance: 0,
            cumplimiento: 0,
            total_cumplimiento: 0,
            total_state: 0
        }
    });
    const token = document.querySelector("[name='csrf-token']").content;

    useEffect(() => {
        if (sessionUser?.id != null) {
            loadData(sessionUser.id);
        }
    }, []);

    const loadData = (user) => {

        let route = "/task/my_dashboard_info/"

        if (props.type != "user") {
            route = "/task/general_dashboard_info/"
        }

        fetch(`${route}${user}`, {
            method: 'GET',
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                setIsLoaded(false);
                setData({
                    user: {
                        name: data.user.name,
                        position: data.user.position,
                        avatar: data.user.avatar,
                    },
                    tasks: {
                        count: data.tasks.count,
                        series_state: data.tasks.series_state,
                        series_time: data.tasks.series_time,
                        labels_state: data.tasks.labels_state,
                        labels_time: data.tasks.labels_time,
                        expired: data.tasks.expired,
                        performance: data.tasks.performance,
                        cumplimiento: data.tasks.cumplimiento,
                        total_cumplimiento: data.tasks.total_cumplimiento,
                        total_state: data.tasks.total_state,
                        tasks_done_or_filed: data.tasks.tasks_done_or_filed,
                        total_open: data.tasks.total_open,
                        fulfilled: data.tasks.fulfilled,
                        fulfilled_not: data.tasks.fulfilled_not,
                        total_vigentes: data.tasks.total_vigentes,
                        vencidas: data.tasks.vencidas,
                        eficacia: data.tasks.eficacia,
                        eficiencia: data.tasks.eficiencia,
                        eficacia_abiertas: data.tasks.eficacia_abiertas,
                        efectividad: data.tasks.efectividad,
                        color_eficacia: data.tasks.color_eficacia,
                        color_eficiencia: data.tasks.color_eficiencia,
                        color_eficacia_abiertas: data.tasks.color_eficacia_abiertas,
                        color_efectividad: data.tasks.color_efectividad,
                        tasks_all_percentage: data.tasks.tasks_all_percentage,
                        total_tasks_account: data.tasks.total_tasks_account,
                        value_divider: data.tasks.value_divider,
                        users_values: data.tasks.users_values,
                        user_titles: data.tasks.user_titles,
                        user_colors: data.tasks.user_colors,
                    }

                })

            });

    }

    const handleChange = (e) => {
        const id = e.target.value;
        setFilterUserId(id);
        loadData(id || sessionUser.id);
    }

    if (isLoaded) {
        return (
            <div className="md-shell md-shell--loading">
                <div className="md-loading-card">
                    <Preloader />
                </div>
            </div>
        )
    }

    const isUser = props.type === "user";
    const tlVariant = isUser ? 'user' : 'company';

    return (
        <div className="md-shell my-dashboard-container">
            <div className="md-ambient" aria-hidden>
                <span className="md-ambient__orb md-ambient__orb--1" />
                <span className="md-ambient__orb md-ambient__orb--2" />
                <span className="md-ambient__orb md-ambient__orb--3" />
            </div>

            {isUser ? (
                <header className="md-hero">
                    <div className="md-hero__main">
                        <div className="md-hero__user">
                            <div className="md-hero__avatar-wrap">
                                <img src={data.user.avatar} alt="" className="md-hero__avatar" />
                            </div>
                            <div className="md-hero__text">
                                <p className="md-hero__kicker">Panel personal</p>
                                <h1 className="md-hero__title">{data.user.name}</h1>
                                <p className="md-hero__role">{data.user.position}</p>
                            </div>
                        </div>
                        {props.estados.show_users && (
                            <div className="md-hero__filter">
                                <label className="md-hero__filter-label" htmlFor="md-dash-user-select">Ver como</label>
                                <select
                                    id="md-dash-user-select"
                                    name="value"
                                    className="md-select"
                                    value={filterUserId}
                                    onChange={handleChange}
                                    aria-label="Ver panel de otro usuario"
                                >
                                    <option value="">Tú (actual)</option>
                                    {dashboardUsers.map(user => (
                                        <option key={user.id} value={String(user.id)}>{user.name}</option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>
                    <div className="md-hero__aside">
                        <div className="md-hero__badge">
                            <span className="md-hero__badge-icon"><i className="fas fa-chart-pie" /></span>
                            <div>
                                <span className="md-hero__badge-title">Seguimiento de tareas</span>
                                <span className="md-hero__badge-sub">Vista en tiempo real</span>
                            </div>
                        </div>
                        <TrafficLights variant={tlVariant} />
                    </div>
                </header>
            ) : (
                <header className="md-hero md-hero--company">
                    <div className="md-hero__main md-hero__main--wide">
                        <div className="md-hero__text">
                            <p className="md-hero__kicker">Vista organización</p>
                            <h1 className="md-hero__title">Desempeño empresarial</h1>
                            <p className="md-hero__role">Indicadores consolidados del equipo</p>
                        </div>
                    </div>
                    <div className="md-hero__aside">
                        <TrafficLights variant={tlVariant} />
                    </div>
                </header>
            )}

            <section className="md-section">
                <h2 className="md-section__title">Resumen operativo</h2>
                <p className="md-section__hint">Distribución de tareas por estado y cumplimiento</p>
                <div className="md-bento">
                    <CardDataThree titleTop="Total" titleLeft="Finalizadas" titleRight="Abiertas" valueTop={data.tasks.count} valueLeft={data.tasks.tasks_done_or_filed} valueRight={data.tasks.total_open} color="#38bdf8" />
                    <CardDataThree titleTop="Finalizadas" titleLeft="Cumplidas" titleRight="No cumplidas" valueTop={data.tasks.tasks_done_or_filed} valueLeft={data.tasks.fulfilled} valueRight={data.tasks.fulfilled_not} color="#a78bfa" />
                    <CardDataThree titleTop="Abiertas" titleLeft="Vigentes" titleRight="Vencidas" valueTop={data.tasks.total_open} valueLeft={data.tasks.total_vigentes} valueRight={data.tasks.vencidas} color="#f472b6" />
                </div>
            </section>

            <section className="md-section">
                <h2 className="md-section__title">Indicadores clave</h2>
                <p className="md-section__hint">Eficacia, eficiencia y rendimiento</p>
                <div className="md-kpi-grid">
                    <CardData idCard="1" text1={props.img_eficacia} text2={{ right: "0px" }} title="Eficacia" value={data.tasks.eficacia + "%"} color={data.tasks.color_eficacia} />
                    <CardData idCard="2" text1={props.img_eficiencia} text2={{ right: "0px" }} title="Eficiencia" value={data.tasks.tasks_done_or_filed > 0 ? data.tasks.eficiencia + "%" : "—"} color={data.tasks.color_eficiencia} />
                    <CardData idCard="3" text1={props.img_rendimiento} text2={{ right: "210px" }} title="Rendimiento actual" value={data.tasks.total_open > 0 ? data.tasks.eficacia_abiertas + "%" : "—"} color={data.tasks.color_eficacia_abiertas} />
                </div>
                <div className="md-kpi-wide">
                    <CardData idCard="4" text1={props.img_desempeño} text2={{ right: "0px" }} title="Desempeño global" value={data.tasks.efectividad + "%"} color={data.tasks.color_efectividad} />
                </div>
            </section>

            {isUser && (
                <section className="md-section md-section--chart">
                    <div className="md-chart-card">
                        <div className="md-chart-card__head">
                            <h3 className="md-chart-card__title">Participación en la empresa</h3>
                            <span className="md-chart-card__pill">{data.tasks.total_tasks_account} tareas totales</span>
                        </div>
                        <div className="md-chart-card__body">
                            {data.tasks.series_state && (
                                <Donutchart colors={['#34d399', '#fbbf24', '#fb7185']} labels={data.tasks.labels_time} series={data.tasks.series_time} />
                            )}
                        </div>
                    </div>
                </section>
            )}
            {!isUser && (
                <section className="md-section md-section--chart">
                    <div className="md-chart-card">
                        <div className="md-chart-card__head">
                            <h3 className="md-chart-card__title">Desempeño del personal</h3>
                            <span className="md-chart-card__pill">Comparativo por colaborador</span>
                        </div>
                        <div className="md-chart-card__body">
                            {data.tasks.series_state && (
                                <Columnchart colors={['#34d399', '#fbbf24', '#fb7185']} labels={data.tasks.user_titles} series={data.tasks.users_values} user_colors={data.tasks.user_colors} />
                            )}
                        </div>
                    </div>
                </section>
            )}
        </div>
    );
}

export default MyDashboard;
WebpackerReact.setup({ MyDashboard });
